import { useMemo } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useFormatter } from 'js/hooks/useFormatter';

import { useDynamicReducerSelector } from '../store';

export const useTransactions = () => {
    const formatter = useFormatter();
    const transactions = useDynamicReducerSelector(prop('transactions'));

    return useMemo(() => transactions.map(transaction => {
        const {
            typeOfWager,
            transactionId,
            winningsAmount,
            transactionDate,
            withheldTaxAmount
        } = transaction;
        const winnings = winningsAmount.amount
            && formatter.formatCurrency(winningsAmount.amount, { currencyCode: winningsAmount.currencyCode });
        const withheldTax = withheldTaxAmount.amount
            && formatter.formatCurrency(withheldTaxAmount.amount, { currencyCode: withheldTaxAmount.currencyCode });

        return {
            winnings,
            typeOfWager,
            withheldTax,
            transactionId,
            transactionDate: formatter.getDateTimeShort(formatter.parseImsDate(transactionDate))
        };
    }), [transactions, formatter]);
};
